import { Suspense } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';

import { ErrorPage } from '~/components/ErrorPage';

import { AutomatedCreatorCampaignPage } from '../pages/AutomatedCreatorCampaignPage/AutomatedCreatorCampaignPage';

export function Router() {
  return (
    <Suspense>
      <Routes>
        <Route element={<Outlet />}>
          <Route index element={<AutomatedCreatorCampaignPage />} />
          <Route path="*" element={<ErrorPage type="notFoundPage" />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

Router.displayName = 'AutomatedCreatorCampaignRouter';
